import { successAction } from '@/src/utils/actions';
import { logError } from '@/src/utils/sentry';
import isEmptyObject from '@/src/utils/object/isEmptyObject';
import getAllFlags from '@/src/redux/selectors/fwf/getAllFlags';
import { FLAGS_UPDATED } from '@/src/redux/types/fwf';

/**
 * Update the flags from the current state
 * @param {object} newFlags
 */
const updateFlags = (newFlags) => (dispatch, getState) => {
  try {
    const state = getState();
    const cachedFlags = getAllFlags(state);

    const updatedFlags = Object.values(newFlags).reduce((result, flag) => {
      if (
        !cachedFlags[flag.key] ||
        flag.variation !== cachedFlags[flag.key].variation
      ) {
        // eslint-disable-next-line no-param-reassign
        result[flag.key] = flag;
      }

      return result;
    }, {});

    if (!isEmptyObject(updatedFlags)) {
      dispatch(
        successAction({
          type: FLAGS_UPDATED,
          payload: { flags: updatedFlags },
        }),
      );
    }
  } catch (error) {
    logError('[UPDATE_FLAGS]', error);
  }
};

export default updateFlags;
